import { render, staticRenderFns } from "./DataProtectionAr.vue?vue&type=template&id=13da7ffa&scoped=true&"
import script from "./DataProtectionAr.vue?vue&type=script&lang=js&"
export * from "./DataProtectionAr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13da7ffa",
  null
  
)

export default component.exports